export const CLEAR_STORE = 'clearstore';
export const ClearStoreEvent = new Event( CLEAR_STORE );
